import WebTable from "../layouts/reports/web/webReport";
import NetworkTable from "../layouts/reports/network/networkReport";

// AWS
import AwsConfigTable from "../layouts/reports/cloud/aws/awsConfig";
import AwsUrlTable from "../layouts/reports/cloud/aws/awsUrl";
import AwsIpTable from "../layouts/reports/cloud/aws/awsIp";

import {
  AzureConfigReport,
  AzureNetworkReport,
  AzureWebReport,
  GcpConfigReport,
  GcpNetworkReport,
  GcpWebReport,
  OciConfigReport,
  OciNetworkReport,
  OciWebReport,
} from "../layouts/reports/cloud/CloudProviderReport";

const dropdownList = [
  {
    key: "web",
    title: "Web Vulnerabilities Report",
    tab: "Web Reports",
    component: WebTable,
  },
  {
    key: "network",
    title: "Network Vulnerabilities Report",
    tab: "Network Reports",
    component: NetworkTable,
  },

  {
    key: "aws",
    title: "AWS Reports",
    tab: "AWS Reports",
    submenu: [
      {
        key: "aws-config",
        title: "AWS Cloud Misconfigurations Report",
        subTab: "AWS Config",
        component: AwsConfigTable,
      },
      {
        key: "aws-ec2",
        title: "AWS EC2 Instance Report",
        subTab: "AWS EC2",
        component: AwsIpTable,
      },
      {
        key: "aws-s3",
        title: "AWS S3 URL Report",
        subTab: "AWS S3",
        component: AwsUrlTable,
      },
    ],
  },

  {
    key: "azure",
    title: "Azure Reports",
    tab: "Azure Reports",
    submenu: [
      {
        key: "azure-config",
        title: "Azure Cloud Misconfigurations Report",
        subTab: "Azure Config",
        component: AzureConfigReport,
      },
      {
        key: "azure-vm",
        title: "Azure VM Instance Report",
        subTab: "Azure VM",
        component: AzureNetworkReport,
      },
      {
        key: "azure-blob",
        title: "Azure Blob URL Report",
        subTab: "Azure Blob",
        component: AzureWebReport,
      },
    ],
  },

  {
    key: "gcp",
    title: "GCP Reports",
    tab: "GCP Reports",
    submenu: [
      {
        key: "gcp-config",
        title: "GCP Cloud Misconfigurations Report",
        subTab: "GCP Config",
        component: GcpConfigReport,
      },
      {
        key: "gcp-gce",
        title: "GCP VM Instance Report",
        subTab: "GCP GCE",
        component: GcpNetworkReport,
      },
      {
        key: "gcp-gcs",
        title: "GCP GCS URL Report",
        subTab: "GCP GCS",
        component: GcpWebReport,
      },
    ],
  },
  {
    key: "oci",
    title: "OCI Reports",
    tab: "OCI Reports",
    submenu: [
      {
        key: "oci-config",
        title: "OCI Cloud Misconfigurations Report",
        subTab: "OCI Config",
        component: OciConfigReport,
      },
      {
        key: "oci-compute",
        title: "OCI Compute IP Report",
        subTab: "OCI Compute",
        component: OciNetworkReport,
      },
      {
        key: "oci-endpoint",
        title: "OCI Endpoint Report",
        subTab: "OCI Endpoint",
        component: OciWebReport,
      },
    ],
  },
];

export default dropdownList;
